const Check = () => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.6265 12.3954V13.406C24.6251 15.7747 23.8581 18.0796 22.4398 19.9768C21.0215 21.874 19.0279 23.2619 16.7564 23.9335C14.4848 24.6051 12.0571 24.5245 9.8351 23.7036C7.61314 22.8827 5.71607 21.3655 4.42681 19.3784C3.13755 17.3912 2.52518 15.0405 2.68104 12.6769C2.83689 10.3133 3.75262 8.06339 5.29165 6.26273C6.83067 4.46207 8.91054 3.20715 11.221 2.68512C13.5316 2.16309 15.9489 2.40192 18.1126 3.366M24.6265 4.61196L13.6419 15.6076L10.3465 12.3122"
        stroke="#032806"
        strokeWidth="2.19693"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Check;
